<template>
  <v-navigation-drawer :value="this.getSideDrawerState" class="sideMenuDrawer" stateless temporary app right>
    <v-card class="three-color-grad sideMenuDrawerWrapper">
      <v-toolbar color="transparent" elevation="0" class="sideMenuHeader" height="70">
        <v-btn fab small class="closeCartBtn" @click="closeSideDrawer">
          <closeBtn/>
        </v-btn>


        <v-switch inset
                  v-if="getInventoryAvailable"
                  :label="parseInventoryMode"
                  v-model="modeSwitcher"
                  class="inventoryMode-switch">
        </v-switch>

      </v-toolbar>

      <v-container class="sideMenuWrapper">
        <v-row style="z-index: 2">
          <v-col
              cols="12"
              v-for="menu in menues.filter(val =>
              val.requires === 0 ||
              (val.requires !== 0 && val.requires === this.getUserRole()) ||
              (val.guard && getPermissions().indexOf(val.guard) > -1))"
              :key="menu.id"
              class="sideNavCol"
              @click="goTo(menu.id)"
          >
            <v-btn class="sideNavBtn"
                   elevation="0"
                   :style="(menu.id === 10 && getCurrentActiveMode === 'mhd') ? 'background-color: black!important;' : ''"
            >
              <Component :is="require(`@/assets/sideNav/${menu.icon}.svg`)"/>
              <span v-text="menu.description"/>

            </v-btn>
          </v-col>
        </v-row>
        <span class="versionNr">Version: {{ versionNr }}</span>
      </v-container>
      <div class="sideMenuBottom">
      <v-btn class="sideNavBtn" @click="logoutAttempt">
        <Component :is="require(`@/assets/sideNav/logout.svg`)"/>
        <span>Ausloggen</span>
      </v-btn>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
import router from '@/router'
import igrosLogo from "@/assets/logo/igrosLogo"
import closeBtn from "@/assets/closeBtn";

export default {
  name: "sideNavigation",
  components: {igrosLogo, closeBtn},

  data:() => {
    return {
      drawerState: false,
      versionNr: null,
      modeSwitcher: false,

      menues: [
          {'id': 1, 'description': 'Meine Bestellungen', 'icon': 'orders', 'requires': 0},
          {'id': 11, 'description': 'Meine Rechnungen', 'icon': 'orders', 'requires': 0},
          {'id': 9, 'description': 'Meine Inventuren', 'icon': 'inventory', 'requires': 0},
          {'id': 2, 'description': 'Mein Konto', 'icon': 'account', 'requires': 0},
          {'id': 7, 'description': 'Neuigkeiten', 'icon': 'news', 'requires': 0},
          {'id': 3, 'description': 'Benutzer erstellen', 'icon': 'create_user', 'requires': 3},
          {'id': 4, 'description': 'Benutzer bearbeiten', 'icon': 'edit_user', 'requires': 3},
          {'id': 5, 'description': 'Liefertage bearbeiten', 'icon': 'delivery_days', 'requires': 3},
          {'id': 8, 'description': 'Inventurtage bearbeiten', 'icon': 'inventory_days', 'requires': 3},
          {'id': 6, 'description': 'Impressum', 'icon': 'imprint', 'requires': 0},
          {'id': 10, 'description': 'MHD-Inventur', 'icon': 'imprint', 'guard': 'LAGER'}
      ]
    }
  },

  methods: {
    ...mapActions({
      logout: 'logout',
      goToImprint: 'goToImprint'
    }),

    ...mapActions('inventory', {
      fetchInventoryAvailable: 'fetchInventoryAvailable'
    }),

    ...mapMutations({
      setSideDrawerState: 'setSideDrawerState',
      setCurrentActiveMode: 'setCurrentActiveMode'
    }),

    ...mapMutations('inventory', {
      setInventoryMode: 'setInventoryMode'
    }),

    ...mapGetters({
      getUserRole: 'getUserRole',
      getPermissions: 'getPermissions'
    }),

    logoutAttempt() {
      this.logout()
    },

    closeSideDrawer() {
      this.setSideDrawerState()
    },

    goTo(id) {
      this.setSideDrawerState()
      switch(id) {
        case 1:
          router.push({name: 'Bestellungen'})
          break
        case 2:
          router.push({name:'Benutzerprofil'})
          break
        case 3:
          router.push({name: 'createUser'})
          break
        case 4:
          router.push({name: 'editUser'})
          break
        case 5:
          router.push({name: 'editDeliveryDays'})
          break
        case 6:
          router.push({name: 'Impressum'})
          break;
        case 7:
          router.push({name: 'News'})
          break
        case 8:
          router.push({name: 'editInventoryDays'})
          break
        case 9:
          router.push({name: 'Inventuren'})
          break
        case 10:
          this.setCurrentActiveMode('mhd')
          break
        case 11:
          router.push({name: 'Rechnungen'})
          break
      }
    },
  },

  computed: {
    ...mapGetters({
      getSideDrawerState: 'getSideDrawerState',
        getCurrentActiveMode: 'getCurrentActiveMode'
    }),

    ...mapGetters('inventory', {
      getInventoryMode: 'getInventoryMode',
      getInventoryAvailable: 'getInventoryAvailable'
    }),

    ...mapState({
      version: 'version'
    }),

    parseInventoryMode() {
      if(this.getInventoryMode) {
        return 'Inventur'
      }
      else {
        return 'Shop'
      }
    }
  },

  watch: {
    modeSwitcher: {
      handler(state) {
        if(state) {
          this.setInventoryMode(true)
        }
        else {
          this.setInventoryMode(false)
        }
      }
    },

    getSideDrawerState: {
      handler(state) {
        if(state) {
          this.fetchInventoryAvailable()
        }
      }
    }
  },

  created() {
    this.versionNr = this.version
  },

  beforeRouteLeave() {
    this.setSideDrawerState()
  },
}
</script>

<style>
  .logoutBtn {
    width: 44px;
    padding-top: 30%;
    top: 20%
  }

  .logoutWrapper {
    grid-row-start: sideMenuEnd;
    grid-row-end: sideEnd;
  }

  .v-list-item--two-line {
    min-height: 56px;
  }

  .sideNavCol {
    width: 100%;
  }

  .sideNavBtn {
    background-color: var(--igros-red) !important;
    width: 100%;
    height: 46px!important;
    padding: 10px 20px!important;
  }

  .sideNavBtn .v-btn__content {
    flex-direction: row;
    justify-content: left;
  }

  .sideNavBtn .v-btn__content span {
    font-size: 16px;
  }

  .sideNavBtn .v-btn__content svg {
    width: 40px;
  }

  .sideMenuBottom {
    padding: 15px;
    background-color: white!important;
    grid-row-start: sideMenuEnd;
    grid-row-end: sidend;
  }

  .inventoryMode-switch.v-input {
    margin-top: 16px!important;
    width: 80px;
  }

  .inventoryMode-switch .v-input__slot {
    flex-direction: column;
  }

  .sideMenuHeader .v-toolbar__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
  }

  .sideMenuHeader .v-toolbar__content .v-label.theme--light {
    margin-top: 5px;
    left: -5px!important;
  }

</style>
